import React from "react";
import { LightBoxCartOutline } from "../vectors/AddToCartIcon";
import ContrastForegroundUtility from "../../../../utils/ContrastForegroundUtility";

interface AddToCartButtonProps {
  primaryColor: string;
  handleClick: () => void;
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  primaryColor,
  handleClick
}) => (
  <div
    className="geo-lt__cart-icon geo-btn--caps"
    onClick={e => {
      e.preventDefault();
      handleClick();
    }}
    style={{
      background: ContrastForegroundUtility.lbFgColor(primaryColor),
      borderColor: ContrastForegroundUtility.lbFgColor(primaryColor),
      color: "white"
    }}
  >
    <LightBoxCartOutline color="white" />
    <span>&nbsp; Add to cart</span>
  </div>
);

export default AddToCartButton;
